import { render } from "./Contato.vue?vue&type=template&id=def65860&scoped=true"
import script from "./Contato.vue?vue&type=script&lang=js"
export * from "./Contato.vue?vue&type=script&lang=js"

import "./contato.scss?vue&type=style&index=0&id=def65860&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def65860"]])

export default __exports__